<template>
    <div class=" px-1 ">
        <HeaderBar/>
        <div
          class="d-flex flex-column mb-2 mt-4"
          style="font-size: 15px; font-weight: 500"
        >
            <div class="add-economic-record-title1 mt-2 text-center "> Gastos</div>
        </div>
        <div class="d-flex flex-column">
            <validation-observer ref="GanForm">
                <div>
                    <b-form @submit.prevent="">
                        <!-- date -->
                        <b-form-group label="Fecha" label-for="vaccine-date">
                            <validation-provider
                            #default="{ errors }" 
                            name="Fecha" 
                            rules="required">
                                <b-form-datepicker v-model="economic.date" class="form-control" 
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                         <!-- submit buttons -->
                        <div class="d-flex justify-content-center mt-2">
                            <b-button class="bg-primary w-75"  @click="AddExpense">
                                Agregar gasto
                            </b-button>
                        </div>

                        <b-table striped hover bordered :items="items" :fields="fields" responsive>
                            <template #cell(description)="data">
                                <validation-provider
                                #default="{ errors }" 
                                name="Descripción" 
                                rules="required">
                                    <b-form-select type="text" :value="data.value" :options="productsOptions" v-model="items[data.index].description"></b-form-select>
                                     <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </template>
                            <template #cell(amount)="data">
                                <validation-provider
                                #default="{ errors }" 
                                name="Monto" 
                                rules="required">
                                    <b-form-input type="number" :value="data.value" v-model="items[data.index].amount"></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </template>
                        </b-table>
                        <!-- <div class="d-flex justify-content-center">
                            <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img>
                        </div> -->
                        <!-- submit buttons -->
                        <div class="d-flex justify-content-center mt-2 mb-4">
                            <b-button class="bg-primary w-75 mb-4" @click="addEconomicRecord">
                                Incluir Registros
                            </b-button>
                        </div>
                    </b-form>
                </div>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BTable, BButton, BImg, BLink,BFormDatepicker, BFormSelect, BForm, BFormGroup, BFormInput, } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'

import axios from 'axios'

export default {
    components: {
        required,
        ValidationProvider,
        ValidationObserver,
        BLink,
        BImg,
        BTable,
        BForm,
        BButton,
        BFormSelect,
        BFormGroup,
        BFormDatepicker,
        BFormInput,
        ControlMenu,
        HeaderBar,
        flatPickr,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 200)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            items: [],
            productsOptions:[],
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            productType:null,
            economic:{
                date:null,
                unit:0,
                amount:0,
                voucher_num:'',
                total:0,
                type:1,
                record_type:2,
                product_id:0
            },
            fields:[
                {key:"description", label:"Tipo de Gasto"},
                {key:"amount", label:"Gasto"},
            ]
        }
    },
    methods:{

        async fetchExpenseTypes(config){
            fetch(this.$apiUrl+"list/economic_record_types", config)
            .then(response => response.json())
            .then(result => {
                this.productsOptions = result.economic_record_types.map(item => {return {value:item.name,text:item.name}})
            })
        },

        AddExpense(){
            let single={
                date:this.economic.date,
                unit:0,
                amount:0,
                voucher_num:'',
                total:0,
                type:2,
                record_type:2,
                product_id:0,
                description:null,
                farm_id:localStorage.getItem('currentFarm'),
            }
            this.items.push(single);
        },

        addEconomicRecord() {
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self=this;
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    console.log(this.items);
                    this.items.forEach(function (expense){
                        expense.total = expense.amount;
                    })
                    var request= this.items.map(items =>this.$http.post("add/economic_records", items, config));
                    axios.all(request)
                    .then(()=>{
                        this.$swal({
                            title: 'Registrso de gastos',
                            text: 'Se insertaron los registros de gastos de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    });
                }
            })
        }
    },
    created(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchExpenseTypes(config);
    }

}
</script>

<style lang="scss">
.incomeProduct {
    font-weight: 600;
    font-size: 24px;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>
